export const UID_MAX_LENGTH = 9
export const uid = () => Math.random().toString(36).substr(2, UID_MAX_LENGTH)

export const DATA_OBOARD_UID = 'data-oboard-uid'
